import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDirection } from './DirectionContext';
import '../i18n';
import * as intl from "@arcgis/core/intl";
import { GrLanguage } from "react-icons/gr";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useTheme } from './ThemeSwitcher/ThemeSwitcher';

//let isLandingPageLangApplied=false;
function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const { direction, setDirection } = useDirection();
  let { theme } = useTheme()
 
  const [language, setLanguage] = useState(
    window.location.pathname == "/" || window.location.pathname == "/home/" ? localStorage.getItem("i18nextLng") || 'en' :
      localStorage.getItem("i18nextLngNotLandingPage") || localStorage.getItem("i18nextLng") || 'en');
  const [isOpen, setIsOpen] = useState(false); // State to control dropdown visibility

  
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  // useEffect(() => {
  //   if(!isLandingPageLangApplied) {
  //   localStorage.setItem("i18nextLngNotLandingPage", localStorage.getItem("i18nextLng") || "en")
  //   isLandingPageLangApplied=true;
  //   }

  // }, [])
  useEffect(() => {
    const savedLanguage =
      window.location.pathname === "/" || window.location.pathname === "/home/"
        ? localStorage.getItem("i18nextLng") || 'en'
        : localStorage.getItem("i18nextLngNotLandingPage") || localStorage.getItem("i18nextLng") || 'en';

    if (i18n.language !== savedLanguage) {
      i18n.changeLanguage(savedLanguage);
      setDirection(savedLanguage === 'ar' ? 'rtl' : 'ltr');
      document.body.setAttribute('dir', savedLanguage === 'ar' ? 'rtl' : 'ltr');
      setLanguage(savedLanguage);
    }
  }, [i18n, setDirection]);

  useEffect(() => {
    console.log('LanguageSwitcher mounted');
  }, []);

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);

    if (window.location.pathname === "/" || window.location.pathname === "/home/") {
      localStorage.setItem('i18nextLng', lang);
      localStorage.setItem('i18nextLngNotLandingPage', lang);
    } else {
      localStorage.setItem('i18nextLngNotLandingPage', lang);
    }

    setLanguage(lang);
    setDirection(lang === 'ar' ? 'rtl' : 'ltr');
    document.body.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
    setIsOpen(false);

    setTimeout(() => {
      Highcharts.charts.forEach(chart => {
        if (chart && chart.update) {
          chart.update({
            exporting: {
              buttons: {
                contextButton: {
                  align: lang === 'ar' ? 'left' : 'right',
                  x: lang === 'ar' ? 5 : -5,
                  text: `<span class="" style="color: ${theme === 'dark' ? '#ffffff' : '#000000'};">
                  ${t('Download')} <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="11" height="12">
                  <path fill="none" stroke="${theme === 'dark' ? '#ffffff' : '#757474'}" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m2 5 6 6 6-6"></path></svg>
             </span>`,
                }
              }
            },
            title: {
              align: lang === 'ar' ? 'right' : 'left'
            }
          }, true, true);
          setTimeout(() => {
            chart.reflow();
          }, 300);
        }
      });
      window.dispatchEvent(new Event('resize'));
    }, 200);
  };

  useEffect(() => {
    if (!language) return;

    setTimeout(() => {
      Highcharts.charts.forEach(chart => {
        if (chart && chart.update) {
          chart.update({
            exporting: {
              buttons: {
                contextButton: {
                  align: language === 'ar' ? 'left' : 'right',
                  x: language === 'ar' ? 5 : -5,
                  text: `<span class="" style="color: ${theme === 'dark' ? '#ffffff' : '#000000'};">
                  ${t('Download')} <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="11" height="12">
                  <path fill="none" stroke="${theme === 'dark' ? '#ffffff' : '#757474'}" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m2 5 6 6 6-6"></path></svg>
             </span>`,
                }
              }
            },
            title: {
              align: language === 'ar' ? 'right' : 'left'
            }
          }, true, true);
          chart.reflow();
        }
      });
    }, 300);

    try {
      intl.setLocale(language);
    } catch (ex) {
      console.log('failed to set arcgis locale', ex);
    }
  }, [language]);


  const allLanguages = [
    { code: 'ar', name: 'عربي', switch: 'عربي' },
    { code: 'en', name: 'English', switch: 'English' }
  ];

  const filteredLanguages = allLanguages.filter(lang => lang.code !== language);

  const handleMouseEnter = () => setIsOpen(true);
  const handleMouseLeave = () => setIsOpen(false);

  return (
    <>
      <div className="language-dropdown" >
        <div
          className={`custom-select`}

        >
          {filteredLanguages.map(lang => (
            <div key={lang.code} onClick={() => changeLanguage(lang.code)}>
              {lang.switch}
            </div>
          ))}

        </div>
      </div>


      <div className="custom-select-mob d-none" onMouseLeave={handleMouseLeave}>
        <div
          className={`custom-select ${isOpen ? 'open' : ''}`}
          onMouseEnter={handleMouseEnter}
        >
          <div className="selected-option">
            {allLanguages.find(lang => lang.code === language)?.name}
          </div>
          {isOpen && (
            <ul className="options-list">
              {filteredLanguages.map(lang => (
                <li key={lang.code} onClick={() => changeLanguage(lang.code)}>
                  {lang.name}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>


      {/* For the mobile version */}

      <div className="custom-langSelect-Mob">
        <div className="custom-select-Mobile">
          <div className="select-trigger" onClick={toggleDropdown} >

            <GrLanguage />

            <div>
              {filteredLanguages.map(lang => (
                <div
                  className={`custom-option-Mobile ${lang.code === language ? 'selected' : ''}`}
                  key={lang.code}
                  data-value={lang.code}
                  onClick={() => {
                    changeLanguage(lang.code)
                  }}
                >
                  {lang.switch}
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>


    </>
  );
}

export default LanguageSwitcher;
